import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
// import AudioPlayer from '@/components/AudioPlayer' // Comentado para desativar o áudio
import { ContentProvider } from '@/contexts/ContentContext'
import ProtectedRoute from '@/components/ProtectedRoute'
import AdminLayout from '@/layouts/AdminLayout'
import AdminLogin from '@/pages/Admin/Login'
import AdminDashboard from '@/pages/Admin/Dashboard'
import AdminContent from '@/pages/Admin/Content'
import AdminContacts from '@/pages/Admin/Contacts'
import AdminSettings from '@/pages/Admin/Settings'
import SEOPage from '@/pages/Admin/SEO'
import Home from '@/pages/Home'

export default function App() {
  // Lista de músicas desativada
  // const audioFiles = [
  //   '/audio/Bodega Cat - Dyalla.mp3',
  //   '/audio/Break Ya Neck - Dyalla.mp3',
  //   '/audio/Cosy - Dyalla.mp3',
  //   '/audio/Drone Shot - Dyalla.mp3',
  //   '/audio/Moonlit - Dyalla.mp3',
  //   '/audio/No Rush - Dyalla.mp3',
  //   '/audio/Not My First Rodeo - Dyalla.mp3'
  // ];

  return (
    <AuthProvider>
      <ContentProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Protected Admin Routes */}
          <Route element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/admin/contacts" element={<AdminContacts />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/seo" element={<SEOPage />} />
          </Route>
          
          {/* Catch all other routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        
        {/* AudioPlayer desativado */}
        {/* {audioFiles.length > 0 && <AudioPlayer audioSrcList={audioFiles} />} */}
      </ContentProvider>
    </AuthProvider>
  )
}